var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.err)?_c('div',{staticClass:"my-5 text-center bolder red-text",domProps:{"innerHTML":_vm._s(_vm.$linebreak(_vm.err))}}):_c('step-01',{on:{"next":_vm.onNext}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }